exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#floatingCirclesG {\r\n    margin: 0;\r\n    margin-top: -16px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/user/user-add-edit/user-add-edit.component.css
// module id = ../../../../../src/app/components/user/user-add-edit/user-add-edit.component.css
// module chunks = 0